var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsEnum, IsNumber, IsObject, IsOptional, IsString, IsUUID, } from 'class-validator';
import { BodyActivity } from '../enums/body-activity.enum.js';
import { UserProfileDto } from './user.profile.dto.js';
export class UserDiagnosisFullSizeDto {
    id;
    createdAt;
    updatedAt;
    userId;
    user;
    bodyWeight;
    bodyHeight;
    bodyActivity;
    patientRisk;
    preExistingConditions;
    allergies;
    get userOfficeId() {
        return this.user?.officeId;
    }
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], UserDiagnosisFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], UserDiagnosisFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], UserDiagnosisFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], UserDiagnosisFullSizeDto.prototype, "userId", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    Exclude(),
    __metadata("design:type", Function)
], UserDiagnosisFullSizeDto.prototype, "user", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserDiagnosisFullSizeDto.prototype, "bodyWeight", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserDiagnosisFullSizeDto.prototype, "bodyHeight", void 0);
__decorate([
    IsEnum(BodyActivity),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserDiagnosisFullSizeDto.prototype, "bodyActivity", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserDiagnosisFullSizeDto.prototype, "patientRisk", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserDiagnosisFullSizeDto.prototype, "preExistingConditions", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserDiagnosisFullSizeDto.prototype, "allergies", void 0);
//# sourceMappingURL=user-diagnosis.full-size.dto.js.map